const set = [
  'Private.Toyota.Audio.CurrentStatus.MediaID',
  'Private.Toyota.Audio.CurrentStatus.Title',
  'Private.Toyota.Audio.CurrentStatus.Playlist',
  'Private.Toyota.Audio.CurrentStatus.Genre',
  'Private.Toyota.Audio.CurrentStatus.Composer',
  'Private.Toyota.Audio.CurrentStatus.Album',
  'Private.Toyota.Audio.CurrentStatus.Artist',
  'Private.Toyota.Audio.CurrentStatus.TimeValue',
  'Private.Toyota.Audio.CurrentStatus.LengthUnit',
  'Private.Toyota.Audio.CurrentStatus.Category',
  'Private.Toyota.Audio.CurrentStatus.PlaybackState',
  'Private.Toyota.Audio.CurrentStatus.CoverArt',
];

export default {
  set,
};
